// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__yd6mS","main":"layout_main__k8zJI"};